import { render, staticRenderFns } from "./CustomFormCompInput.vue?vue&type=template&id=319c4e35"
import script from "./CustomFormCompInput.vue?vue&type=script&lang=js"
export * from "./CustomFormCompInput.vue?vue&type=script&lang=js"
import style0 from "./CustomFormCompInput.vue?vue&type=style&index=0&id=319c4e35&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports